import React from "react";
import { Star, Stethoscope } from "lucide-react";
import { useSeoSettings } from "../lib/useSeoSettings";

/**
 * Visible trust line only — the clinic's own Google rating is shown as a fact with a link to the
 * profile, and is deliberately NOT marked up as a product rating (self-declared ratings are ignored
 * or penalised by Google).
 */
export const TrustStrip = ({ className = "" }) => {
    const conf = useSeoSettings();
    const clinic = conf.clinic || {};
    const founder = conf.founder || {};
    if (!conf.trust_line && !clinic.name) return null;

    const rating = conf.show_rating !== false && clinic.rating ? clinic.rating : "";
    const body = (
        <>
            {rating && (
                <span className="inline-flex items-center gap-1.5 mono text-[11px] tracking-[0.14em] text-gold"
                    data-testid="trust-rating">
                    <Star className="w-3.5 h-3.5 fill-current" /> {rating}
                    <span className="text-zinc-500">
                        on Google{clinic.name ? ` · ${clinic.name}` : ""}
                    </span>
                </span>
            )}
            {conf.trust_line && (
                <span className="text-sm text-zinc-400" data-testid="trust-line">{conf.trust_line}</span>
            )}
            {founder.name && (
                <span className="inline-flex items-center gap-1.5 text-sm text-zinc-400" data-testid="trust-founder">
                    <Stethoscope className="w-3.5 h-3.5 text-lime" />
                    {founder.name}{founder.job_title ? ` · ${founder.job_title}` : ""}
                </span>
            )}
        </>
    );

    return (
        <div className={`flex flex-wrap items-center gap-x-6 gap-y-2 border-y border-white/10 py-4 ${className}`}
            data-testid="trust-strip">
            {clinic.google_profile_url
                ? <a href={clinic.google_profile_url} target="_blank" rel="noreferrer nofollow"
                    className="flex flex-wrap items-center gap-x-6 gap-y-2 hover:opacity-80 transition-opacity"
                    data-testid="trust-strip-link">{body}</a>
                : body}
        </div>
    );
};

export default TrustStrip;
